import Marquee from "react-fast-marquee";

const ITEMS = [
    "Aucune avance de frais",
    "Toutes assurances",
    "Intervention à domicile",
    "Garantie à vie",
    "Jusqu'à 450 € offerts",
    "7j/7 de 8h à 20h",
];

export const EditorialMarquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative border-y border-gold/20 bg-[#0A0E17] py-6 overflow-hidden"
    >
        <Marquee speed={28} gradient={false} pauseOnHover>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="font-serif italic text-xl sm:text-2xl text-gray-300 px-8 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rotate-45 bg-gold/80" aria-hidden="true" />
                </span>
            ))}
        </Marquee>
    </div>
);
